import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '../_services/local/authentication.service';
import { Router } from '@angular/router';
import { ToasterService } from 'angular2-toaster';


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService, 
        private router : Router,
        private toasterService : ToasterService) { 

        }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            if (err.status === 401) {
                // auto logout if 401 response returned from api
                this.toasterService.pop('info', 'Opa :|', 'Opa seu token expirou... Faça login novamente!');
                this.authenticationService.logout();
                this.router.navigate(['/usuarios/login']);
            }else if(err.status === 0){
                this.toasterService.pop('error', 'Ops :(', 'API fora do ar... Acione o suporte!');
            }else if(err.status === 403){
                this.toasterService.pop('warning', 'Sinto muito : |', 'Você não tem permissão para acessar esse recurso...');
            }
            const error = err.error;//.error.message || err.statusText;
            return throwError(error);
        }))
    }
}